import { Mp4Box } from "./Mp4Box.class";

export class tfdt extends Mp4Box {}
